'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _lodash = require('lodash.pick');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isempty');

var _lodash4 = _interopRequireDefault(_lodash3);

var _validate = require('../../helpers/validate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactInformation = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ContactInformation, _Component);

  function ContactInformation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ContactInformation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactInformation.__proto__ || (0, _getPrototypeOf2.default)(ContactInformation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popoverOpen: false,
      name: _this.props.name,
      email: _this.props.email,
      phone: _this.props.phone,
      url: _this.props.url,
      organization: _this.props.organization
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ContactInformation, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = this.state;
      if (nextProps !== this.props) {
        state = (0, _reactAddonsUpdate2.default)(state, {
          $merge: {
            name: nextProps.name,
            email: nextProps.email,
            phone: nextProps.phone,
            url: nextProps.url,
            organization: nextProps.url
          }
        });

        this.setState(state);
      }
    }
  }, {
    key: 'getFieldsState',
    value: function getFieldsState() {
      return {
        name: this.state.name,
        email: this.state.email,
        phone: this.state.phone,
        url: this.state.url
      };
    }
  }, {
    key: 'getContactState',
    value: function getContactState() {
      return (0, _lodash2.default)(this.state, ['name', 'email', 'phone', 'url']);
    }
  }, {
    key: 'contactEmpties',
    value: function contactEmpties() {
      var empties = [];
      var contact = this.getContactState();

      for (var key in contact) {
        if ((0, _lodash4.default)(contact[key])) {
          empties.push(key);
        }
      }

      return empties;
    }
  }, {
    key: 'contactIsEmpty',
    value: function contactIsEmpty() {
      var contact = this.getContactState();
      var empties = this.contactEmpties();

      return empties.length >= (0, _keys2.default)(contact).length;
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.refs.contactInformationBoxPopover.hide();
    }
  }, {
    key: 'handleOK',
    value: function handleOK() {
      var _this2 = this;

      var onChange = this.props.onChange;

      this.setState(this.getFieldsState(), function () {
        _this2.refs.contactInformationBoxPopover.hide();
        onChange(_this2.getFieldsState());
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(property, value) {
      this.setState((0, _defineProperty3.default)({}, property, value));
    }
  }, {
    key: 'handleChangeUrl',
    value: function handleChangeUrl(event) {
      this.handleChange('url', event.target.value);
    }
  }, {
    key: 'handleChangeName',
    value: function handleChangeName(event) {
      this.handleChange('name', event.target.value);
    }
  }, {
    key: 'handleChangeEmail',
    value: function handleChangeEmail(event) {
      this.handleChange('email', event.target.value);
    }
  }, {
    key: 'handleChangePhone',
    value: function handleChangePhone(event) {
      this.handleChange('phone', event.target.value);
    }
  }, {
    key: 'focusFirstInput',
    value: function focusFirstInput() {
      document.querySelector('#contactInformationPopover input').focus();
    }
  }, {
    key: 'handleOnCheckedCopyInfo',
    value: function handleOnCheckedCopyInfo() {
      var organization = this.props.organization;


      this.setState({
        url: organization.contact_url || '',
        phone: organization.contact_phone || '',
        email: organization.contact_email || '',
        name: organization.contact_name || ''
      });
    }
  }, {
    key: 'isCopyDisabled',
    value: function isCopyDisabled() {
      var _state = this.state,
          url = _state.url,
          phone = _state.phone,
          email = _state.email,
          name = _state.name;
      var _props$organization = this.props.organization,
          orgUrl = _props$organization.contact_url,
          orgPhone = _props$organization.contact_phone,
          orgEmail = _props$organization.contact_email,
          orgName = _props$organization.contact_name;


      return !orgUrl && !orgName && !orgPhone && !orgEmail || (!orgUrl && !url || url === orgUrl) && (!orgPhone && !phone || phone === orgPhone) && (!orgEmail && !email || email === orgEmail) && (!orgName && !name || name === orgName);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          name = _state2.name,
          email = _state2.email,
          phone = _state2.phone,
          url = _state2.url;
      var _props = this.props,
          errors = _props.errors,
          popoverContainer = _props.popoverContainer,
          organization = _props.organization,
          polyglot = _props.polyglot;


      var hasErrors = (0, _keys2.default)(errors).reduce(function (acc, k) {
        return acc || !!errors[k].length > 0;
      }, false);

      var boxUI = '';
      if (this.contactIsEmpty()) {
        // Empty
        boxUI = _react2.default.createElement(ContactInformation.Empty, { polyglot: polyglot });
      } else {
        // HasContact
        boxUI = _react2.default.createElement(ContactInformation.HasContact, {
          hasErrors: hasErrors,
          name: name,
          email: email,
          phone: phone,
          url: url,
          polyglot: polyglot
        });
      }

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'contactInformationBoxPopover',
          trigger: 'click',
          placement: 'top',
          rootClose: true,
          onEntered: this.focusFirstInput.bind(this),
          container: popoverContainer,
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'contactInformationPopover', className: 'contact-information-box-popover' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(_components.Input, {
                  type: 'text',
                  label: polyglot.t('contactInformation.name'),
                  value: name,
                  onChange: this.handleChangeName.bind(this)
                }),
                _react2.default.createElement(_components.Input, {
                  type: 'text',
                  label: polyglot.t('contactInformation.email'),
                  value: email,
                  onChange: this.handleChangeEmail.bind(this)
                }),
                _react2.default.createElement(_components.Input, {
                  type: 'text',
                  label: polyglot.t('contactInformation.telephone'),
                  value: phone,
                  onChange: this.handleChangePhone.bind(this)
                }),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'url',
                    validationState: (0, _validate.validate)('urlOrEmpty', this.state.url, errors.contact_url) },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    null,
                    polyglot.t('contactInformation.website')
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    value: url,
                    onChange: this.handleChangeUrl.bind(this) }),
                  _react2.default.createElement(
                    _reactBootstrap.HelpBlock,
                    null,
                    polyglot.t('contactInformation.specifyProtocol')
                  )
                ),
                organization && _react2.default.createElement(
                  'div',
                  { className: 'copy-organization-info' },
                  _react2.default.createElement('hr', null),
                  _react2.default.createElement(
                    'button',
                    {
                      type: 'button',
                      disabled: this.isCopyDisabled(),
                      className: 'btn btn-default btn-outline',
                      onClick: this.handleOnCheckedCopyInfo.bind(this)
                    },
                    polyglot.t('contactInformation.copyOrganizationInfo')
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'popover-actions' },
                  _react2.default.createElement(
                    'div',
                    { className: 'buttons' },
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'btn btn-default btn-outline',
                        onClick: this.handleCancel.bind(this)
                      },
                      polyglot.t('button.cancel')
                    ),
                    '\xA0',
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'btn btn-primary',
                        onClick: this.handleOK.bind(this)
                      },
                      'OK'
                    )
                  )
                )
              )
            )
          )
        },
        boxUI
      );
    }
  }], [{
    key: 'Empty',
    value: function Empty(_ref2) {
      var onClick = _ref2.onClick,
          polyglot = _ref2.polyglot;

      return _react2.default.createElement(
        'div',
        { className: 'dashed-box contact-information empty', onClick: onClick },
        _react2.default.createElement('span', { className: 'icon-cg-phone left-icon' }),
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('contactInformation.contactInfo')
        )
      );
    }
  }, {
    key: 'HasContact',
    value: function HasContact(_ref3) {
      var hasErrors = _ref3.hasErrors,
          email = _ref3.email,
          name = _ref3.name,
          onClick = _ref3.onClick,
          phone = _ref3.phone,
          url = _ref3.url,
          polyglot = _ref3.polyglot;

      return _react2.default.createElement(
        'div',
        { className: 'line-box event-content-box contact-information has-contact' + (hasErrors ? ' has-error' : ''), onClick: onClick },
        _react2.default.createElement(
          'h3',
          { className: 'box-header' },
          polyglot.t('contactInformation.contactInfo')
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-content' },
          _react2.default.createElement(
            'div',
            null,
            name
          ),
          _react2.default.createElement(
            'div',
            null,
            email
          ),
          _react2.default.createElement(
            'div',
            null,
            phone
          ),
          _react2.default.createElement(
            'div',
            null,
            url
          )
        )
      );
    }
  }]);
  return ContactInformation;
}(_react.Component), _class.propTypes = {
  email: _propTypes2.default.string,
  errors: _propTypes2.default.object.isRequired,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  phone: _propTypes2.default.string,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  url: _propTypes2.default.string,
  organization: _propTypes2.default.object
}, _temp2);
exports.default = ContactInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/ContactInformation.js
// module id = 2203
// module chunks = 0